<template>
  <div class="box" :class="margin_top_class">
    {{text}}
  </div>
</template>

<script>
export default {
  name: "MainTitle",
  props: {
    text: {type: String},
    margin_top: {type: String, default: 'top'},
  },
  data() {
    return {
      margin_top_class: '',
    }
  },
  mounted() {
    if (this.margin_top === 'short') {
      this.margin_top_class = 'short';
    } else {
      this.margin_top_class = 'high'
    }
  }

}
</script>

<style scoped>
.box{
  min-height: clamp(4rem, 8vw, 6rem);
  line-height: 1.2;
  text-align: center;
  font-size: var(--ecs-font-lg);
  color: #61005f;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  white-space: normal;
}
.high{
  /* margin-top: 11vh; */
}
.short{
  margin-top: 2vh;
}
</style>
